<script setup lang="ts">
const paginationContext = usePaginationContext();
</script>

<template>
  <div
    aria-live="polite"
    aria-atomic="true"
    class="sr-only"
  >
    {{
      $t('Pagination.Aria.ListUpdated', {
        pageNumber: paginationContext.currentPage.value,
        totalPages: paginationContext.totalPages.value
      })
    }}
  </div>
</template>
